import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { ADD_USER } from "./actionType"
import { addNewUserError, addNewUserSuccess,usersLoading } from "./action"
//Include Both Helper File with needed methods
import { postNewUser } from "../../../helpers/backend_helper"
import "toastr/build/toastr.min.css"
import toast from "react-hot-toast";

function* newUser({ payload: { user, history, id } }) {
  try {
    const data = {}
    data["firstName"] = user.firstName
    data["lastName"] = user.lastName
    data["email"] = user.email
    data["phoneNumber"] = user.phoneNumber
    data["clientCode"] = user.clientCode
    if (id) {
      data["userId"] = id
    }
    yield put(usersLoading(true))
    const response = yield call(postNewUser, data)
    yield put(usersLoading(false))
    if (response.status === 'error') {
      toast.error(response.message)
    } else {
      toast.success(response.message)
      yield put(addNewUserSuccess(response))
      history.push("/users");
    }
  } catch (error) {
    yield put(usersLoading(false))
    yield put(addNewUserError(error))
    toast.error(error.response.data.message)
  }
}

function* AddUserSaga() {
  yield takeEvery(ADD_USER, newUser)
}

export default AddUserSaga
